import { api } from "./api";

export const getProfileInfoApi = (params) => {
  return api.get(`/distributor/order/get-profile-info`);
};

export const currentOrderListApi = (params) => {
  return api.get(`/distributor/order/current-order-list`, { params: params });
};

export const orderHistoryListApi = (params) => {
  return api.get(`/distributor/order/order-history-list`, { params: params });
};
export const cfaOrderListApi = (params) => {
  return api.get(`/distributor/order/cfa-orders`, { params: params });
};

export const orderDetailApi = (params) => {
  return api.get(`/distributor/order/order-view-upload-invoice`, {
    params: params,
  });
};

export const updateOrderStatusApi = (params) => {
  return api.post(
    `/distributor/order/update-order-status`,
    JSON.stringify(params),
  );
};

export const uploadInvoice = (params) => {
  return api.post(`/distributor/order/upload-invoice`, params, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateInvoice = (params) => {
  return api.post(`/distributor/order/update-invoice`, JSON.stringify(params));
};

export const exportReconciliationApi = (params) => {
  return api.post(`/distributor/order/stock-reconciliation-export`, params);
};

export const companyListApi = (params) => {
  return api.get("/distributor/order/company-list");
};

export const supplyOrderCFAApi = (params) => {
  return api.post(`/distributor/order/place-to-cfa`, JSON.stringify(params));
};
export const supplyOrderDetailApi = (params) => {
  return api.get(`/distributor/order/cfa-order-view`, {
    params: params,
  });
};

export const CFAupdateInvoice = (params) => {
  return api.post(
    `/distributor/order/upload-cfa-invoice`,
    JSON.stringify(params),
  );
};
export const orderRemarksReasonListApi = (params) => {
  return api.get(`/distributor/order/rejection-reason-list`);
};
